import { BusinessHoursWeekdayMap } from 'types';
import { Features } from '@tock/coretypes';
import { LocalDate } from 'js-joda';
import { ServiceWeekdayMap } from 'state/services';
import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';
import { oc } from 'ts-optchain';
import { serviceDateSelector } from 'selectors/service/serviceAppSelector';
import getServiceDayDetails from 'utils/getServiceDayDetails';

function computeServiceObjectsForFilteringByDay(
  serviceDate: string | undefined,
  servicesForWeekday: ServiceWeekdayMap,
  features: Features,
  publicHoursForWeekday: BusinessHoursWeekdayMap
) {
  if (!serviceDate) {
    return undefined;
  }
  const parsedServiceDate = LocalDate.parse(serviceDate);
  return getServiceDayDetails(
    parsedServiceDate,
    features.PUBLIC_HOURS_BASED_SERVICE_FILTER &&
      // If they have no public hours defined at all, still fall back to reservation hours
      Object.values(publicHoursForWeekday).some((hours) => hours.length > 0)
      ? publicHoursForWeekday
      : servicesForWeekday
  );
}

export default createSelector(
  serviceDateSelector,
  (state: StoreType) => oc(state).services.forWeekday({}),
  (state: StoreType) => state.features.features,
  (state: StoreType) => oc(state).publicHours.forWeekday({}),
  computeServiceObjectsForFilteringByDay
);

export const servicesByDaySelector = createSelector(
  serviceDateSelector,
  (state: StoreType) => oc(state).services.forWeekday({}),
  (serviceDate, servicesForWeekday) => {
    if (!serviceDate) {
      return undefined;
    }
    const parsedServiceDate = LocalDate.parse(serviceDate);
    return getServiceDayDetails(parsedServiceDate, servicesForWeekday);
  }
);
